import { Outlet } from 'react-router-dom'

import { Box, Button, Title } from '@factorialco/deprecated-design-system'
import { SpendingPoliciesListPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import Landing from 'modules/finance/components/SpendingPolicies/List/Landing'
import Overview from 'modules/finance/components/SpendingPolicies/List/Overview'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const SpendingPoliciesListPage = () => {
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()

  const { loading, data, error } = useQuery(SpendingPoliciesListPageDocument, {
    variables: {
      companyId: company.id.toString(),
      companyIdInt: company.id,
    },
  })

  const hasExpensePolicySettings =
    data?.features?.featuresConnection?.nodes.find(
      (feature) => feature.name === 'dev_expenses_policy_settings'
    )?.enabled ?? false

  const spendingPolicies = data?.finance?.spendingPoliciesConnection.nodes || []

  const canCreatePolicies = data?.finance?._policies.spendingPolicyCreate.can ?? false

  if (hasExpensePolicySettings) {
    const expensesPage = data?.handbookPages?.pagesConnection?.nodes[0]

    const linkTo = expensesPage
      ? navigation.pages.page.fullPath({ pageId: expensesPage.id })
      : navigation.pages.list.fullPath()

    const title = expensesPage
      ? i18n.t('spending_policies.moved_to_settings.existing_policy.title')
      : i18n.t('spending_policies.moved_to_settings.no_policy.title')
    const description = expensesPage
      ? i18n.t('spending_policies.moved_to_settings.existing_policy.description')
      : i18n.t('spending_policies.moved_to_settings.no_policy.description')
    const cta = expensesPage
      ? i18n.t('spending_policies.moved_to_settings.existing_policy.cta')
      : i18n.t('spending_policies.moved_to_settings.no_policy.cta')

    return (
      <ResponsivePage.Body variant="full" showHeader={false} loading={loading} error={error}>
        <Box
          justifyContent="center"
          textAlign="center"
          alignItems="center"
          gap="s32"
          paddingTop="s96"
          paddingBottom="s96"
        >
          <Title
            variant="500"
            illustration="list-document"
            title={title}
            description={description}
            centered
          />
          <Button.Router to={linkTo}>{cta}</Button.Router>
        </Box>
      </ResponsivePage.Body>
    )
  }

  return (
    <ResponsivePage.Body variant="full" showHeader={false} loading={loading} error={error}>
      {spendingPolicies.length ? (
        <Overview canCreatePolicies={canCreatePolicies} spendingPolicies={spendingPolicies} />
      ) : (
        <Landing />
      )}
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default SpendingPoliciesListPage
